var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1446,
    height: 148,
    viewBox: "0 0 1446 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.6007C114.324 1.08021 328.965 -27.8228 578.249 46.7451C789.727 109.987 1162.07 112.071 1430.94 113.974V138.166H0V35.6007Z",
    fill: "#D70E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.3964C86.1575 30.0739 341.467 -24.2891 633.981 60.1547C784.907 103.736 986.895 113.974 1129.39 113.974C1271.88 113.974 1400.21 113.974 1446 113.974C1446 128.018 1446 133.273 1446 147.226H0V69.3964Z",
    fill: "#002853"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWaves);
export default __webpack_public_path__ + "static/media/topWaves.1b2ddbc2c593904d982a41960158fef0.svg";
export { ForwardRef as ReactComponent };